export const FLIGHTS_HEADER = "Flights";

export const UPDATE_CALENDAR_TEXT = "Updating your calendar";

export const CHOOSE_DATE = "Choose your dates";

export const INFO_NEW_PACKAGES_CTA_BODY_TEXT =
  "Book a hotel + flight as a package and save more with our select package rates.";

export const INFO_NEW_PACKAGES_CTA_HEADER = "Packages";


export const CORPORATE_INFO_NEW_PACKAGES_CTA_BODY_TEXT =
  "Book your hotel + flight together with an all-in-one checkout.";

export const CORPORATE_INFO_NEW_PACKAGES_CTA_SAVE_MORE =
  "Save time and hassle when you book together";
export const CORPORATE_INFO_NEW_PACKAGES_FLIGHT_LIST_ENTRY_CTA_TEXT =
  "Book your hotel + flight together with an all-in-one checkout.";
export const CORPORATE_HOTELS_AND_FLIGHTS_INFO_NEW_PACKAGES_CTA_HEADER = "Hotel + flight";
